import { module } from "angular";
import { get, includes } from "lodash";

import type { IEnumService, IIPAddress } from "../../Models";
import { Protocol } from "../../Models";

import type { IIpValidationService } from "./IIpValidationService";

export class IpValidationService implements IIpValidationService {
    public static $inject: string[] = ["mmEnumService"];

    constructor(private readonly enumService: IEnumService) {}

    public isPrivateIP(ipAddress: IIPAddress): boolean {
        const privateIPRegExp = /^(?:10|127|172\.(?:1[6-9]|2[0-9]|3[01])|192\.168)\..*/g;
        return privateIPRegExp.test(get(ipAddress, "externalAddress"));
    }

    public isHttp(ipAddress: IIPAddress): boolean {
        const httpPort = 80;
        return get(ipAddress, "protocol") === Protocol[httpPort];
    }

    public getDefaultProtocolPort(protocolStr: string): number {
        const enumVal = Protocol[protocolStr as keyof typeof Protocol];
        return enumVal % 100000;
    }

    public isWrongPortForProtocol(ipAddress: IIPAddress): boolean {
        // check if used port belongs to another protocol
        if (ipAddress) {
            const ports = this.enumService.enumToArray(Protocol).map((item) => this.getDefaultProtocolPort(item.value));
            const defaultPort = this.getDefaultProtocolPort(ipAddress.protocol);

            return includes(ports, ipAddress.port) && ipAddress.port !== defaultPort;
        }
        return false;
    }
}

module("mmServices").service("irIpValidationService", IpValidationService);
